<template>

  <div class="card-base card-shadow--medium widget small-widget queue-widget">
    <div class="widget-value ph-10">
      <div class="flex mb-10 mt-10 align-center">
        <span class="mr-5 flex justify-center align-center">
          <v-svg width="18" height="18" class="voxo-orange" sprite="exit"/>
        </span>
        <el-input
          class="widget-name-input ml-10"
          v-model="widgetName"
        />
        <el-button
          @click="removeWidget"
          class="table-action-button ml-10"
        >
          <i class="el-icon-delete voxo-dark-red" />
        </el-button>
      </div>

      <h1 class="m-0 text-truncate voxo-blue text-center stat-number">
        {{ totalExitsValue }}
      </h1>
       <div class="flex justify-space-between mb-10">
         <div class="stat-breakdown">
           <div class="text-left">
             <span> {{ exitKeyValue }}</span>
           </div>
           <h5 class="mt-0 mb-0"> KEY </h5>
         </div>
         <div class="stat-breakdown">
           <div class="text-right">
             <span> {{ exitTimeoutValue }}</span>
           </div>
           <h5 class="mt-0 mb-0"> TIMEOUT </h5>
         </div>
       </div>
    </div>

    <div class="stat-widget-table ph-10" v-show="isMultiQueue">
      <vxe-table
        round
        ref="xGrid"
        height="100%"
        border="inner"
        class="user-stats-table"
        empty-text="No Data"
        sync-resize
        auto-resize
        :show-overflow="true"
        :checkbox-config="{checkAll: determineCheckAll()}"
        @checkbox-change="checkboxesChanged"
        @checkbox-all="checkboxesChanged"
        :scroll-y="{enabled: true, gt: 10, oSize: 0}"
        :data="queueStoreData"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="30"
        />
        <vxe-table-column
          field="queueId"
          title="Queue"
          min-width="200"
          sortable
          :formatter="getQueueName"
        />
        <vxe-table-column
          field="totalExits"
          title="Count"
          min-width="80"
          sortable
          sort-type="number"
        />
      </vxe-table>
    </div>

  </div>

</template>

<script>

import {mapGetters} from "vuex";
import {debounce} from "lodash";

export default {
  name: 'TransferredCalls',
  props: {
    widgetIndex: {required: true},
    title: {required: true},
    filterQueueIds: {required: true},
    queueNameKey: {required: true},
  },
  data() {
    return {
      widgetName: this.title,
      totalExitsValue: 0,
      exitKeyValue: 0,
      exitTimeoutValue: 0,
      filtersActive: false,
      filterQueues: this.filterQueueIds,
      viewStyle: 'default'
    }
  },
  computed: {

    ...mapGetters('queueDashQueues', {queueStoreData: 'list'}),

    isMultiQueue() {
      return this.queueStoreData.length > 1;
    },

    totalExits() {
      return this.$store.state.queueManagerAggregates.totalExits;
    },

    exitKey() {
      return this.$store.state.queueManagerAggregates.exitKey;
    },

    exitTimeout() {
      return this.$store.state.queueManagerAggregates.exitTimeout;
    }

  },
  watch: {
    totalExits: debounce(function () {
      this.totalExitsValue = this.filtersActive ? this.getFilteredValue('totalExits') : this.totalExits;
    }, 150),
    exitKey: debounce( function () {
      this.exitKeyValue = this.filtersActive ? this.getFilteredValue('exitKey') : this.exitKey;
    }, 150 ),
    exitTimeout: debounce(function () {
      this.exitTimeoutValue = this.filtersActive ? this.getFilteredValue('exitTimeout') : this.exitTimeout;
    }, 150),
    widgetName: debounce(function() {
      if(this.widgetName === this.title) return;
      this.$emit('nameUpdate', {name: this.widgetName, index: this.widgetIndex});
    }, 750),
    filterQueues: debounce(function () {
      this.$emit('filterQueuesUpdate', {filterQueueIds: this.filterQueues, index: this.widgetIndex});
    }, 750)
  },
  methods: {

    getQueueName(data) {
      const { cellValue } = data;
      return this.queueNameKey[cellValue] ? this.queueNameKey[cellValue] : 'Unknown';
    },

    removeWidget(){
      this.$emit('removeWidget', this.widgetIndex);
    },

    checkboxesChanged({records}) {
      this.filterQueues = records.map(item => item.queueId);

      if(this.filterQueues.length === this.queueStoreData.length){
        this.totalExitsValue = this.totalExits;
        this.exitKeyValue = this.exitKey;
        this.exitTimeoutValue = this.exitTimeout;
        this.filtersActive = false;
        return;
      }

      this.filtersActive = true;
      this.filterValues();
    },

    getFilteredValue(key) {
      let value = 0;
      for (let item of this.queueStoreData) {
        if (this.filterQueues.includes(item.queueId)) {
          value += item[key];
        }
      }
      return value;
    },

    filterValues() {

      let completed = 0;
      let key = 0;
      let timeout = 0;

      for (let item of this.queueStoreData) {
        if (this.filterQueues.includes(item.queueId)) {
          completed += item.totalExits;
          key += item.exitKey;
          timeout += item.exitTimeout;
        }
      }

      this.totalExitsValue = completed;
      this.exitKeyValue = key;
      this.exitTimeoutValue = timeout;
    },

    determineCheckAll() {

      const hasFilter = this.filterQueues.length !== this.queueStoreData.length;

      if(!hasFilter){
        this.getInitialValue();
        return true;
      }

      if(hasFilter){
        this.filtersActive = true;
        this.updateCheckboxes();
        return false;
      }

    },

    async updateCheckboxes() {
      setTimeout(() => {
        const checkedRows = this.queueStoreData.filter(item => this.filterQueues.includes(item.queueId));
        const grid = this.$refs.xGrid;
        if(grid) {
          grid.setCheckboxRow(checkedRows,checkedRows);
          this.totalExitsValue = this.getFilteredValue('totalExits');
          this.exitKeyValue = this.getFilteredValue('exitKey');
          this.exitTimeoutValue = this.getFilteredValue('exitTimeout');
        }
      }, 500)
    },

    getInitialValue() {
      setTimeout( () => {
        this.totalExitsValue = this.getFilteredValue('totalExits');
        this.exitKeyValue = this.getFilteredValue('exitKey');
        this.exitTimeoutValue = this.getFilteredValue('exitTimeout');
      }, 500)
    }
  }
}

</script>
